import { Component } from '@angular/core';

@Component({
    selector: 'btl-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
    public cmsBlockId: string = 'https://www.bouyguestelecom.fr/header_prefix';
    public linksRegex: RegExp = /href="http(s?):\/\/www.bouyguestelecom.fr/gim;
    public originDomain: string;

    constructor() {
        this.originDomain = `href="${window.origin}`;
    }
}
